import { INextButtonProps } from "./EditDocumentInterfaces";
import { useState, useEffect } from "react";
import { Button, Spinner } from "react-bootstrap";
import { ComponentStruct } from "../../common/Interfaces";
import { guid_mapping, languages } from "../../common/Contants";
import { EditDocumentAsync } from "../../api/simDocuments/PutDocumentService";
import SuccessPopUp from "../generic_components/SuccessPopUp";
export default function NextButton({
  selectedType,
  selectedDescription,
  selectedLanguages,
  selectedFile,
  selectedReason,
  selectedComment,
  documentReference,
  linkType,
  onErrorMessages,
}: INextButtonProps) {
  const [disabledNext, setDisabledNext] = useState(true);
  const isTypeSelected = (type: string) => type !== "deselect";
  const isDescriptionValid = (description: ComponentStruct | null) =>
    description?.label !== "deselect" || description === null;
  const isInputValid = (file: string) => file !== "";
  const isReasonValid = (reason: string | null) =>
    reason === null || reason !== "";
  const [load, setLoad] = useState(false);
  const [successPopUp, setSuccessPopUp] = useState(false);

  useEffect(() => {
    onErrorMessages([]);
    if (
      isTypeSelected(selectedType.label) &&
      isDescriptionValid(selectedDescription) &&
      selectedLanguages.length > 0 &&
      isInputValid(selectedFile) &&
      isReasonValid(selectedReason)
    ) {
      setDisabledNext(false);
    } else {
      setDisabledNext(true);
    }
  }, [
    selectedType,
    selectedDescription,
    selectedLanguages,
    selectedFile,
    selectedReason,
  ]);

  const TypeGuidMapping = (
    type: ComponentStruct,
    description: ComponentStruct | null
  ) => {
    description = description?.label == "deselect" ? null : description;
    const result = guid_mapping.find(
      (item) =>
        item.description?.key === description?.key &&
        item.type?.key === type.key
    );
    return result?.guid ?? "00000000-0000-0000-0000-000000000000";
  };

  useEffect(() => {
    const putData = async () => {
      try {
        await EditDocumentAsync({
          documentReference,
          documentTypeGuid: TypeGuidMapping(selectedType, selectedDescription),
          url: linkType == "Url" ? selectedFile : null,
          fileName: linkType == "File" ? selectedFile : null,
          comment: selectedComment != "" ? selectedComment : null,
          languages:
            selectedLanguages.length == languages.length
              ? ["all"]
              : selectedLanguages,
        });
        onErrorMessages([]);
        setSuccessPopUp(true);
      } catch (error: any) {
        if (
          error.response &&
          error.response.data &&
          error.response.data.errors
        ) {
          const errors = error.response.data.errors;
          const messages = errors.map((err: any) => err.message);
          onErrorMessages(messages);
        } else {
          onErrorMessages([error.message]);
        }
      } finally {
        setLoad(false);
      }
    };

    if (load) {
      putData();
    }
  }, [load]);

  const handleNext = () => {
    setLoad(true);
  };

  return (
    <>
      {load ? (
        <Spinner animation="border" />
      ) : (
        <Button
          className={`btn btn-primary custom-margin`}
          disabled={disabledNext}
          onClick={handleNext}
        >
          Next
        </Button>
      )}
      <SuccessPopUp
        showPopup={successPopUp}
        message="Document was successfully updated"
      />
    </>
  );
}
